import React from "react"

const SectionHero = () => (
  <section className="hero2">
    <div className="wrap two">
      <div>
        <h1>A decade of helping hospitals succeed in bundled payments</h1>
        <p className="lede">
          Since 2016, Avant-garde Health has helped hospitals lower episode
          spending and improve quality under Medicare bundled payment models.
          Our clients include some of the nation’s largest health systems.
        </p>
      </div>
      <div className="avg12 v2">
        <div className="a12-top">
          <b>11%</b>
          <div>
            <span className="a12-main">Bundled Payment Earnings</span>
            <span className="a12-sub">
              In the 2 most recent CMS BPCI Advanced (bundled payments)
              performance periods, our clients on average beat their target
              prices by 11%.
            </span>
          </div>
        </div>
        <div
          className="a12-bar"
          role="img"
          aria-label="Client spending averaged 11 percent below the CMS target price"
        >
          <div className="a12-track">
            <div className="a12-fill" />
            <div className="a12-tgt" />
          </div>
          <div className="a12-lbls">
            <span className="l-cl">Our clients’ spending</span>
            <span className="l-tg">CMS target price</span>
          </div>
        </div>
      </div>
    </div>
  </section>
)

export default SectionHero
